export default function About() {
  const containerStyle = {
    maxWidth: '700px',
    margin: '0 auto',
    padding: '24px',
    fontFamily: 'Georgia, serif',
    lineHeight: '1.7',
    color: '#333',
  };

  const headingStyle = {
    fontSize: '32px',
    fontWeight: 'bold',
    marginBottom: '20px',
  };

  const paragraphStyle = {
    fontSize: '18px',
    marginBottom: '16px',
  };

  return (
    <div style={containerStyle}>
      <h2 style={headingStyle}>About the Pelter Family</h2>
      
      <p style={paragraphStyle}>
        Welcome to the cozy corner of the internet we call home! This website is lovingly maintained by the Pelter family—a small but lively bunch who believe in celebrating the little things, cherishing each moment, and sharing stories as we journey through life together.
      </p>

      <p style={paragraphStyle}>
        Here, you'll find glimpses into our lives: snapshots from family adventures, heartfelt updates, silly moments we never want to forget, and maybe even a few recipes or projects we’re proud of. It’s our way of staying connected with friends near and far, and keeping memories alive in a digital scrapbook of sorts.
      </p>

      <p style={paragraphStyle}>
        We invite you to reach out with warm greetings, curious questions, or kind inquiries. Whether you’re an old friend, a distant relative, or a new acquaintance, we’re always happy to hear from you.
      </p>

      <p style={paragraphStyle}>
        Thanks for stopping by—you’re always welcome here.
      </p>
    </div>
  );
}
